import { useEffect, useState } from 'react';
import cns from 'classnames';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { useAuth } from '@zep/auth';
import { Language } from '@zep/types';
import { getResizedImage } from '@zep/utils';
import { getStoreCategoryIndex, StoreCategoryNumber } from '../../../../consts';
import { useStoreItemDetail } from '../../../../services';
import { AssetCommonHashIdProps } from '../../../../types/StoreTypes';
import S from './AssetIntroduce.module.scss';
import AssetSummary from './AssetSummary';
const MAX_PREVIEW_IMAGE_SIZE = 74;
const AssetIntroduce = ({
  assetHashId
}: AssetCommonHashIdProps) => {
  const {
    user
  } = useAuth();
  const {
    locale
  } = useRouter();
  const {
    t
  } = useTranslation(['store']);
  const [selectedThumbnailIndex, setSelectedThumbnailIndex] = useState<number>(0);
  const assetDetails = useStoreItemDetail(assetHashId, locale as Language, !!user?.isEdu);

  // 에셋 프리뷰 이미지 배열에 메인썸네일 이미지를 항상 가지고 있어야함.
  const objectPreviewList = [{
    hashId: assetDetails.data?.item.hashId,
    finalFileUrl: assetDetails.data?.item.finalImageUrl
  }, ...(assetDetails.data?.item.objects ?? []).sort((a, b) => a.order - b.order)];
  const mapOrAppPreviewList = assetDetails.data ? [...(assetDetails.data.item?.finalPreviewImageUrls || [])] : [];

  // 맵의 경우에는 맵 썸네일 이미지를 리스트의 맨 앞에 추가해준다.
  if (getStoreCategoryIndex(assetDetails.data?.item.category) === StoreCategoryNumber.map) {
    mapOrAppPreviewList.unshift(assetDetails.data?.item.finalImageUrl ?? '');
  }

  /**
   * 개별 썸네일 클릭 이벤트
   * @param index
   */
  const handleAttachmentOnClick = (index: number) => {
    setSelectedThumbnailIndex(index);
  };

  /**
   * 마우스 우클릭 방지
   * @param event
   */
  const handleRightClickPrevent = (event: MouseEvent) => {
    event.preventDefault();
  };
  useEffect(() => {
    document.addEventListener('contextmenu', handleRightClickPrevent);
    return () => {
      document.removeEventListener('contextmenu', handleRightClickPrevent);
    };
  });
  if (!assetDetails.isSuccess) {
    return <></>;
  }
  const {
    item
  } = assetDetails.data;
  const isObjectCategory = getStoreCategoryIndex(item.category) === StoreCategoryNumber.object;
  return <div className={S.asset_gallery_wrapper} data-sentry-component="AssetIntroduce" data-sentry-source-file="AssetIntroduce.tsx">
      <div className={S.asset_images_wrapper}>
        <div className={cns(S.asset_thumbnail_wrapper)}>
          {isObjectCategory ? <>
              <img className={cns(S.thumbnail_image, {
            hide: selectedThumbnailIndex !== 0
          })} src={objectPreviewList[0]?.finalFileUrl} alt="asset-img" />
              <img className={cns(S.thumbnail_image, S.scale_double, {
            hide: selectedThumbnailIndex === 0
          })} src={objectPreviewList[selectedThumbnailIndex]?.finalFileUrl} alt="asset-img" />
            </> : <img className={S.thumbnail_image} src={mapOrAppPreviewList[selectedThumbnailIndex]} alt="asset-img" />}
          <div className={S.asset_thumbnail_watermark}>
            {item.player?.finalMarketName ?? ''}
          </div>
        </div>
        <div className={S.asset_overflow_wrapper}>
          {
        // 오브젝트를 제외한 맵, 앱 프리뷰
        !isObjectCategory && item.finalPreviewImageUrls.length && <div className={S.asset_attachments_wrapper}>
                {mapOrAppPreviewList.map((url: any, index: number) => <div key={index} className={cns(S.asset_attachment, {
            [S.object_selection_active]: index === selectedThumbnailIndex
          })} onClick={() => handleAttachmentOnClick(index)}>
                    <img src={getResizedImage(url, MAX_PREVIEW_IMAGE_SIZE)} alt="object-attachment" />
                  </div>)}
              </div>}
          {
        // 오브젝트 프리뷰
        objectPreviewList.length > 0 && isObjectCategory && <div className={S.asset_attachments_wrapper}>
                {objectPreviewList.map((object: any, index: number) => <div key={object.hashId} className={cns({
            [S.object_selection_active]: index === selectedThumbnailIndex
          }, S.asset_attachment)} onClick={() => handleAttachmentOnClick(index)} aria-selected={index === selectedThumbnailIndex ? 'true' : 'false'}>
                    <img src={object.finalFileUrl} alt="object-attachment" />
                  </div>)}
              </div>}
        </div>
      </div>
      <div className={S.asset_summary_wrapper}>
        <AssetSummary assetHashId={assetHashId} data-sentry-element="AssetSummary" data-sentry-source-file="AssetIntroduce.tsx" />
      </div>
      <div className={S.details_desc}>
        <label>{t('store:store_introduce_description')}</label>
        <div dangerouslySetInnerHTML={{
        __html: item.description || ''
      }} />
      </div>
    </div>;
};
export default AssetIntroduce;